import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CrudService } from './crud.service';
import { Bookings } from '../models/bookings';

@Injectable({
  providedIn: 'root'
})

export class BookingsService extends CrudService<Bookings, string> {
  protected _http: HttpClient;

  constructor() {
    const _http = inject(HttpClient);

    super(_http, `${environment.baseUrl}/bookings`);

    this._http = _http;
  }

  availability(params: { [key: string]: string | number }): Observable<any> {
    return this._http.get<any>(`${environment.baseUrl}/bookings/availability`, {
      params: new HttpParams({ fromObject: params as any }),
    });
  }

}

